import * as React from 'react';

import { AreaChart, CartesianGrid, XAxis, YAxis, Tooltip, Area, ResponsiveContainer, Legend } from 'recharts';
import { Paper, Typography, LinearProgress } from '@material-ui/core';
import { NumberConvert, MoneyFullBRL } from '../../../../../services';

// tslint:disable-next-line:no-empty-interface
export interface IMarketShareBookstoreShareAverageTicketEvolutionProps {
    data : any;
    loading : boolean;
}

// tslint:disable-next-line:no-empty-interface
export interface IMarketShareBookstoreShareAverageTicketEvolutionState {
    customFilter: {
        isChart: boolean
    },
}

export interface IMarketShareBookstoreShareAverageTicketEvolutionDataChart {
    averageTicket: number;
    averageTicketLabel: string;
    averageTicketMarket: number;
    averageTicketMarketLabel: string;
    day: string;
}



const dataFilled = (data: any) => {
    return data && data.marketShareBookstoreShareAverageTicketEvolution && !!data.marketShareBookstoreShareAverageTicketEvolution.length
}

// statless component
const CustonTooltipData = (props: any) => {

    let content;
    props.payload !== null &&  props.payload.length !== undefined && props.payload.length > 0 ? content = props.payload[0].payload : content = undefined;

    return (
        <div className="tooltip-box">
            <table>
                <tbody>
                    <tr className="tooltip-text">
                        <td className="tooltip-title" colSpan={2}> {content && content.day} </td>
                    </tr>
                    <tr className="tooltip-text">
                        <td className="tooltip-title">Loja:</td>
                        <td className="tooltip-content">{content && content.averageTicketLabel}</td>
                    </tr>
                    <tr className="tooltip-text">
                        <td className="tooltip-title">Mercado:</td>
                        <td className="tooltip-content">{content && content.averageTicketMarketLabel}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

// statless component
const MarketShareBookstoreShareAverageTicketEvolutionChart = ({ data, loading } : 
    { data: IMarketShareBookstoreShareAverageTicketEvolutionDataChart[], loading:boolean }) => (
        <ResponsiveContainer width="100%" height={370}>
            <AreaChart
                data={data}
                margin={{ top: 10, right: 30, left: 0, bottom: 0, }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="day" />
                <YAxis />
                <Tooltip content={<CustonTooltipData isAnimationActive={false}  />} />
                <Legend verticalAlign="bottom" height={20}/>
                <Area name="Loja" type="monotone" dataKey="averageTicket" stroke="#FF6A14" fill="#FF6A14" fillOpacity={0.3} />
                <Area name="Mercado" type="monotone" dataKey="averageTicketMarket" stroke="#323232" fill="#323232" fillOpacity={0.3} />
            </AreaChart>
        </ResponsiveContainer>
);

export class MarketShareBookstoreShareAverageTicketEvolution extends React.Component<IMarketShareBookstoreShareAverageTicketEvolutionProps, IMarketShareBookstoreShareAverageTicketEvolutionState> {

    constructor(props: IMarketShareBookstoreShareAverageTicketEvolutionProps) {
        super(props);
        this.state = {
          customFilter: {
            isChart: true,
          },
        }
    }

    public render() {
        return (
            <Paper className="publisher-sale-block panel-block" >
                <Typography variant="headline" className="panel-title" component="title">
                    Evolução Ticket Médio - 30 Dias
                </Typography>

                {
                    this.props.loading
                    ?
                    <LinearProgress />
                    :
                    (
                        dataFilled(this.props.data)
                        ?
                        (
                            <MarketShareBookstoreShareAverageTicketEvolutionChart 
                                data={this.convertData(this.props.data.marketShareBookstoreShareAverageTicketEvolution)}
                                loading={this.props.loading} 
                            />
                        )
                        :
                        (<Typography variant="body2" className="comparative" component="p">
                            Não há informações de vendas
                        </Typography>)
                    )
                }
            </Paper>
        );
    }

    private convertData = (data: any[]) => {

        const mappedData: IMarketShareBookstoreShareAverageTicketEvolutionDataChart[] = [];

        if(data) {
            data.forEach(e => {
                const item: IMarketShareBookstoreShareAverageTicketEvolutionDataChart = {
                    averageTicket: NumberConvert(e.average_ticket.toString()),
                    averageTicketLabel: MoneyFullBRL(e.average_ticket.toString()),
                    averageTicketMarket: NumberConvert(e.average_ticket_market.toString()),
                    averageTicketMarketLabel: MoneyFullBRL(e.average_ticket_market.toString()),
                    day: e.day,
                    
                };
                mappedData.push(item);
            });
        }

        return mappedData;
    }
    
}



// WEBPACK FOOTER //
// ./src/component/market/bookstore/marketShare/average-ticket-evolution/MarketShareBookstoreShareAverageTicketEvolution.tsx